import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createStore, applyMiddleware, compose} from 'redux';
import {Provider} from "react-redux";
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';
import setUpInterceptors from './services/interpeceptors.service'
import {BrowserRouter} from "react-router-dom";
import {registerLicense} from "@syncfusion/ej2-base";

import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import {msalConfig} from "./authConfig";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
registerLicense(process.env.REACT_APP_TOKEN_SYNCFUSION);

const store = createStore(
    rootReducer,
    composeEnhancer(applyMiddleware(thunk))
);
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </Provider>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

setUpInterceptors(store)
reportWebVitals();
